import { render, staticRenderFns } from "./MenusTagLists.vue?vue&type=template&id=51f56472&scoped=true&"
import script from "./MenusTagLists.vue?vue&type=script&lang=js&"
export * from "./MenusTagLists.vue?vue&type=script&lang=js&"
import style0 from "./MenusTagLists.vue?vue&type=style&index=0&id=51f56472&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f56472",
  null
  
)

export default component.exports